function autocomplete(settings) {
  // just an alias to minimize JS file size
	const doc = document;
	const container = settings.container != null ? settings.container : doc.createElement('div');
	const containerStyle = container.style;
	const userAgent = navigator.userAgent;
	const mobileFirefox = userAgent.indexOf('Firefox') !== -1 && userAgent.indexOf('Mobile') !== -1;
	const debounceWaitMs = settings.debounceWaitMs || 0;
	// 'keyup' event will not be fired on Mobile Firefox, so we have to use 'input' event instead
	const keyUpEventName = mobileFirefox ? 'input' : 'keyup';
	let items = [];
	let inputValue = '';
	let minLen = 2;
	const showOnFocus = settings.showOnFocus;
	let selected;
	let keypressCounter = 0;
	let debounceTimer;
	if (settings.minLength !== undefined) {
		minLen = settings.minLength;
	}
	if (!settings.input) {
		throw new Error('input undefined');
	}
	const input = settings.input;
	container.className = 'select-list ' + (settings.className || '');
	/**
     * Detach the container from DOM
     */
	function detach() {
		let parent = container.parentNode;
		parent.classList.add('is-hidden');
		if (container.childElementCount > 0) {
			while (container.hasChildNodes()) {
				container.removeChild(container.firstChild);
			}
		}
	}
	/**
     * Clear debouncing timer if assigned
     */
	function clearDebounceTimer() {
		if (debounceTimer) {
			window.clearTimeout(debounceTimer);
		}
	}
	/**
     * Attach the container to DOM
     */
	function attach() {
		let parent = container.parentNode;
		parent.classList.remove('is-hidden');
		if (!container.parentNode) {
			doc.body.appendChild(container);
		}
	}
	/**
     * Check if container for autocomplete is displayed
     */
	function containerDisplayed() {
		let parent = container.parentNode;
		return (parent.classList.contains('is-hidden') ? false : !!parent);
	}
	/**
     * Clear autocomplete state and hide container
     */
	function clear() {
		keypressCounter++;
		items = [];
		inputValue = '';
		selected = undefined;
		detach();
	}
	/**
     * Update autocomplete position
     */
	function updatePosition() {
		if (!containerDisplayed()) {
			return;
		}
		containerStyle.height = 'auto';
		containerStyle.width = input.offsetWidth + 'px';
		const inputRect = input.getBoundingClientRect();
		const top = inputRect.top + input.offsetHeight;
		let maxHeight = window.innerHeight - top;
		containerStyle.top = top + 'px';
		containerStyle.bottom = '';
		containerStyle.left = inputRect.left + 'px';
		if (settings.customize) {
			settings.customize(input, inputRect, container, maxHeight);
		}
	}
	/**
     * Redraw the autocomplete div element with suggestions
     */
	function update() {
		// delete all children from autocomplete DOM container
		while (container.firstChild) {
			container.removeChild(container.firstChild);
		}
		// function for rendering autocomplete suggestions
		// eslint-disable-next-line no-unused-vars
		let render = function (item, currentValue) {
			const itemElement = doc.createElement('div');
			itemElement.textContent = item.label || '';
			return itemElement;
		};
		if (settings.render) {
			render = settings.render;
		}
		// function to render autocomplete groups
		// eslint-disable-next-line no-unused-vars
		let renderGroup = function (groupName, currentValue) {
			const groupDiv = doc.createElement('div');
			groupDiv.textContent = groupName;
			return groupDiv;
		};
		if (settings.renderGroup) {
			renderGroup = settings.renderGroup;
		}

		const fragment = doc.createDocumentFragment();
		let prevGroup = '#9?$';
		items.forEach(function (item) {
			if (item.group && item.group !== prevGroup) {
				prevGroup = item.group;
				const groupDiv = renderGroup(item.group, inputValue);
				if (groupDiv) {
					groupDiv.className += ' group';
					fragment.appendChild(groupDiv);
				}
			}
			const div = render(item, inputValue);
			if (div) {
				div.addEventListener('click', function (ev) {
					settings.onSelect(item, input);
					clear();
					ev.preventDefault();
					ev.stopPropagation();
				});
				if (item === selected) {
					div.className += ' selected';
				}
				fragment.appendChild(div);
			}
		});

		container.appendChild(fragment);
		if (items.length < 1) {
			if (settings.emptyMsg) {
				const empty = doc.createElement('li');
				empty.className = 'empty';
				empty.textContent = settings.emptyMsg;
				container.appendChild(empty);
			}
			else {
				clear();
				return;
			}
		}
		attach();
		updatePosition();
		updateScroll();
	}
	function updateIfDisplayed() {
		if (containerDisplayed()) {
			update();
		}
	}
	function resizeEventHandler() {
		updateIfDisplayed();
	}

	function keyupEventHandler(ev) {
		const keyCode = ev.which || ev.keyCode || 0;
		const ignore = [35 /* End */, 36 /* Home */, 38 /* Up */, 13 /* Enter */, 27 /* Esc */, 39 /* Right */, 37 /* Left */, 16 /* Shift */, 17 /* Ctrl */, 18 /* Alt */, 20 /* CapsLock */, 91 /* WindowsKey */, 9 /* Tab */];
		for (const key of ignore) {
			if (keyCode === key) {
				return;
			}
		}
		// the down key is used to open autocomplete
		if (keyCode === 40 /* Down */ && containerDisplayed()) {
			return;
		}
		startFetch(0 /* Keyboard */);
	}
	/**
     * Automatically move scroll bar if selected item is not visible
     */
	function updateScroll() {
		const elements = container.getElementsByClassName('selected');
		if (elements.length > 0) {
			let element = elements[0];
			// make group visible
			const previous = element.previousElementSibling;
			if (previous && previous.className.indexOf('group') !== -1 && !previous.previousElementSibling) {
				element = previous;
			}
			if (element.offsetTop < container.scrollTop) {
				container.scrollTop = element.offsetTop;
			}
			else {
				const selectBottom = element.offsetTop + element.offsetHeight;
				const containerBottom = container.scrollTop + container.offsetHeight;
				if (selectBottom > containerBottom) {
					container.scrollTop += selectBottom - containerBottom;
				}
			}
		}
	}
	/**
     * Select the previous item in suggestions
     */
	function selectPrev() {
		if (items.length < 1) {
			selected = undefined;
		}
		else {
			if (selected === items[0]) {
				selected = items[items.length - 1];
			}
			else {
				for (let i = items.length - 1; i > 0; i--) {
					if (selected === items[i] || i === 1) {
						selected = items[i - 1];
						break;
					}
				}
			}
		}
	}
	/**
     * Select the next item in suggestions
     */
	function selectNext() {
		if (items.length < 1) {
			selected = undefined;
		}
		if (!selected || selected === items[items.length - 1]) {
			selected = items[0];
			return;
		}
		for (let i = 0; i < (items.length - 1); i++) {
			if (selected === items[i]) {
				selected = items[i + 1];
				break;
			}
		}
	}
	function keydownEventHandler(ev) {
		const keyCode = ev.which || ev.keyCode || 0;
		if (keyCode === 38 /* Up */ || keyCode === 40 /* Down */ || keyCode === 27 /* Esc */) {
			const containerIsDisplayed = containerDisplayed();
			if (keyCode === 27 /* Esc */) {
				clear();
			}
			else {
				if (!containerDisplayed || items.length < 1) {
					return;
				}
				keyCode === 38 /* Up */
					? selectPrev()
					: selectNext();
				update();
			}
			ev.preventDefault();
			if (containerIsDisplayed) {
				ev.stopPropagation();
			}
			return;
		}
		if (keyCode === 13 /* Enter */ && selected) {
			ev.preventDefault();
			settings.onSelect(selected, input);
			clear();
		}
	}
	function focusEventHandler() {
		if (showOnFocus) {
			startFetch(1 /* Focus */);
		}
	}
	function startFetch(trigger) {
		// if multiple keys were pressed, before we get update from server,
		// this may cause redrawing our autocomplete multiple times after the last key press.
		// to avoid this, the number of times keyboard was pressed will be
		// saved and checked before redraw our autocomplete box.
		const savedKeypressCounter = ++keypressCounter;
		const val = input.value;
		if (val.length >= minLen || trigger === 1 /* Focus */) {
			clearDebounceTimer();
			debounceTimer = window.setTimeout(function () {
				settings.fetch(val, function (elements) {
					if (keypressCounter === savedKeypressCounter && elements) {
						items = elements;
						inputValue = val;
						selected = items.length > 0 ? items[0] : undefined;
						update();
					}
				}, 0 /* Keyboard */);
			}, trigger === 0 /* Keyboard */ ? debounceWaitMs : 0);
		}
		else {
			clear();
		}
	}
	function blurEventHandler() {
		// we need to delay clear, because when we click on an item, blur will be called before click and remove items from DOM
		setTimeout(() => {
			if (doc.activeElement !== input) {
				clear();
			}
		}, 200);
	}
	/**
     * Fixes #26: on long clicks focus will be lost and onSelect method will not be called
     */
	container.addEventListener('mousedown', function (evt) {
		evt.stopPropagation();
		evt.preventDefault();
	});
	/**
     * This function will remove DOM elements and clear event handlers
     */
	function destroy() {
		input.removeEventListener('focus', focusEventHandler);
		input.removeEventListener('keydown', keydownEventHandler);
		input.removeEventListener(keyUpEventName, keyupEventHandler);
		input.removeEventListener('blur', blurEventHandler);
		window.removeEventListener('resize', resizeEventHandler);
		clearDebounceTimer();
		clear();
		// prevent the update call if there are pending AJAX requests
		keypressCounter++;
	}
	// setup event handlers
	input.addEventListener('keydown', keydownEventHandler);
	input.addEventListener(keyUpEventName, keyupEventHandler);
	input.addEventListener('blur', blurEventHandler);
	input.addEventListener('focus', focusEventHandler);
	window.addEventListener('resize', resizeEventHandler);
	return {
		destroy
	};
}

export default autocomplete;